const en = {
  // Nav
  nav_home: 'Home',
  nav_products: 'Products',
  nav_about: 'About Us',
  nav_contact: 'Contact',
  nav_explore: 'Explore',

  // Hero
  hero_badge: 'Cat Scratchers · Professional Quality',
  hero_title1: 'Living with Cats',
  hero_title2: 'Every Scratch',
  hero_title3: 'Is a Joyful Ritual',
  hero_desc: 'Premium natural materials combined with ergonomic design — helping cats love their scratchers and making your home more beautiful. Koorpet, protecting the happiness behind every paw print.',
  hero_btn_products: 'Explore Products',
  hero_btn_about: 'Our Story',
  hero_stat1_num: '6+',
  hero_stat1_label: 'Years in Industry',
  hero_stat2_num: '50+',
  hero_stat2_label: 'Product Lines',
  hero_stat3_num: '100K+',
  hero_stat3_label: 'Cats Love Us',
  hero_scroll: 'Scroll Down',

  // Featured Products
  featured_label: 'Featured Products',
  featured_title: 'Best Sellers',
  featured_subtitle: 'Cats\' Favorite Collection',
  featured_view_all: 'View All Products',
  featured_empty: 'No featured products yet',

  // Features Section
  features_badge: 'Core Advantages',
  features_title: 'Why Choose Koorpet',
  features_desc: 'Every product goes through rigorous R&D testing to provide cats with the best scratching experience',
  feature1_title: 'Triple-Layer High Density',
  feature1_desc: 'Premium corrugated cardboard with triple hot-press technology, 2x denser than ordinary products, more durable and long-lasting.',
  feature2_title: 'Natural Catnip Infused',
  feature2_desc: 'Organic catnip evenly infused between cardboard layers, releasing lasting natural fragrance that attracts cats to use it.',
  feature3_title: 'Non-Toxic Eco Certified',
  feature3_desc: 'All materials pass national environmental testing — formaldehyde-free, heavy metal-free, safe even if cats chew on it.',
  feature4_title: 'Ergonomic Design',
  feature4_desc: 'Based on feline scratching behavior research, optimized angles and heights perfectly match cats\' natural scratching posture.',

  // Brand Section
  brand_label: 'Dedicated Craftsmanship',
  brand_title1: 'Dedicated Craftsmanship',
  brand_title2: 'For One Perfect Cat Scratcher',
  brand_desc: 'Founded in 2024, Koorpet is a leading brand dedicated to cat scratcher R&D and production in China. Our factory spans 4,000 square meters with fully automated production lines and an annual capacity of 2 million units. We firmly believe that a good cat scratcher not only protects furniture but also enhances cats\' quality of life. Every process, from raw material selection to finished product, undergoes strict quality control.',
  brand_years_num: '2024',
  brand_years_label: 'Founded In',
  brand_years_desc: 'With a 4,000 sqm modern factory and fully automated production lines, continuously providing high-quality cat scratchers for cat families worldwide.',
  brand_cert1_label: 'National Quality Cert.',
  brand_cert1_sub: 'ISO 9001 Certified',
  brand_cert2_label: 'Natural Eco Materials',
  brand_cert2_sub: 'Non-Toxic Certified',
  brand_cert3_label: 'Export to 10+ Countries',
  brand_cert3_sub: 'International Standards',
  brand_cert4_label: '100K+ Cats',
  brand_cert4_sub: 'Trusted Choice',
  brand_cta: '',

  // CTA Section
  cta_quote_label: 'Cat Owner\'s Voice',
  cta_quote: '"Since using Koorpet, my sofa is finally safe!"',
  cta_label: 'Take Action',
  cta_title1: 'Let Your Cat Love',
  cta_title2: 'Their Own Territory',
  cta_desc: 'Over 100 thousand cats have chosen Koorpet. Natural materials, thoughtful design, strict quality control — every product is the best gift for your cat. Order now and enjoy quality life.',
  cta_btn: 'Shop Now',

  // Reviews Section
  reviews_title: 'Real Cat Owner Reviews:',
  reviews_subtitle: 'Genuine reviews from cat owners across the country',
  review1_name: 'Orange Cat Mom',
  review1_content: 'Bought the Cloud Series, my orange tabby fell in love on day one! Great quality, sturdy cardboard, the catnip scent is very appealing to him. Highly recommended!',
  review1_product: 'Cloud Series Cat Scratcher',
  review2_name: 'Ragdoll Owner',
  review2_content: 'The Sisal Scratching Post is finely crafted, the sisal rope is wound tightly, the base is very stable. My ragdoll scratches on it every day, the sofa is finally safe!',
  review2_product: 'Sisal Scratching Post',
  review3_name: "Calico Cat's Human",
  review3_content: 'The Wave Scratcher has a clever design, reversible for double the life, amazing value. My cat loves lying on it to sleep, two birds with one stone!',
  review3_product: 'Wave Cat Scratcher',
  review4_name: 'British Shorthair Dad',
  review4_content: "Packaging is so thoughtful, product quality is impeccable. Customer service is very responsive too, instant replies. I've repurchased three times, it's my cat's favorite brand!",
  review4_product: 'Catnip Round Cat Scratcher',

  // About Banner
  about_breadcrumb_home: 'Home',
  about_breadcrumb_about: 'About Us',
  about_banner_title: 'About Koorpet',
  about_banner_desc: 'Craftsmanship and quality, dedicated to the happiness of every cat. We believe great products make the bond between people and pets even more beautiful.',

  // Company Stats
  stat1_num: '2024',
  stat1_label: 'Founded',
  stat1_sub: 'Deep in the pet industry',
  stat2_num: '50+',
  stat2_label: 'Products',
  stat2_sub: 'Covering all cat scenarios',
  stat3_num: '100K+',
  stat3_label: 'Cats',
  stat3_sub: 'Trust Koorpet',
  stat4_num: '30+',
  stat4_label: 'Patents',
  stat4_sub: 'Continuous innovation',

  // Brand Story
  story_label: 'Our Story',
  story_float_num: '2024',
  story_float_desc: 'Deep in cat scratcher field, focused on quality and innovation',
  story_title1: 'From One Cat Scratcher',
  story_title2: 'to a Brand\'s Birth',
  story_p1: 'Founded in 2024, Koorpet is a leading brand dedicated to cat scratcher R&D and production in China. We operate a 4,000 square meter modern factory with fully automated production lines and an annual capacity of 2 million units.',
  story_p2: 'With years of pet industry experience, our founder recognized the lack of products on the market that truly pursue quality and user experience design. Determined to create Koorpet, he set out to redefine the cat scratcher with higher standards.',
  story_p3: 'From raw material selection to finished product, every process undergoes strict quality control. We adhere to the philosophy of "natural materials, thoughtful design, strict quality control", dedicated to providing the best scratching experience for every cat. Today, Koorpet has become a trusted cat scratcher brand, with products sold in many countries and regions.',
  story_founder_name: 'John Yu',
  story_founder_role: 'Founder of Koorpet',
  story_founder_quote: '"We don\'t just make cat scratchers — we create a better living space for every cat family."',

  // Timeline
  timeline_label: 'Milestones',
  timeline_title: 'Our Journey',
  timeline_desc: 'From OEM manufacturing to own brand, every step is steady. These are the footprints of Koorpet\'s growth.',
  milestone1_title: 'OEM Business Launch',
  milestone1_desc: 'Started providing OEM cat scratcher manufacturing services for international pet brands, establishing supply chain foundations and building production expertise and quality control experience.',
  milestone2_title: 'Factory Expansion',
  milestone2_desc: 'Expanded a 4,000 sqm modern factory, introduced fully automated production lines, with annual capacity reaching 5 million units.',
  milestone3_title: 'Export Breakthrough',
  milestone3_desc: 'OEM products exported to 10+ countries and regions, serving over 50 overseas clients, with quality recognized internationally.',
  milestone4_title: 'Brand Preparation',
  milestone4_desc: 'Assembled an independent R&D team, prepared the own brand Koorpet, completed the first batch of original product designs and patent layout.',
  milestone5_title: 'Koorpet Established',
  milestone5_desc: 'Koorpet brand was officially established, the first high-density corrugated cardboard cat scratcher series launched to great market reception.',
  milestone6_title: 'Product Line Expansion',
  milestone6_desc: 'Launched sisal scratching posts, cat tree series and other new products, passed ISO 9001 and other international certifications, brand influence continued to expand.',
  milestone7_title: 'User Milestone',
  milestone7_desc: 'Served over 100 thousand cat families, Koorpet has become a leading cat scratcher brand in China, continuing to lead the industry.',

  // Team Section
  team_label: 'Our Team',
  team_title: 'Core Team',
  team_desc: 'A group of true cat lovers, crafting every product with expertise and passion',
  team_more: 'Plus',
  team_more2: 'passionate Koorpet professional team members behind the scenes',
  team1_name: 'John Yu',
  team1_role: 'Founder',
  team1_desc: 'Previously served as channel director at a leading industry enterprise, with deep insight into the pet products market. Based on a profound understanding of cat welfare and an unwavering pursuit of product quality, founded Koorpet in 2024, leading the team from OEM manufacturing to own brand, achieving a breakthrough from zero to one.',
  team1_tag1: 'Brand Founding',
  team1_tag2: 'Channel Expansion',
  team2_name: 'Lin Xiaowen',
  team2_role: 'Chief Designer',
  team2_desc: 'Graduated from Central Academy of Fine Arts in Industrial Design, 8 years in pet product design, led the appearance design of 30+ Koorpet products.',
  team2_tag1: 'Product Design',
  team2_tag2: 'User Experience',
  team3_name: 'Wang Jianguo',
  team3_role: 'R&D Director',
  team3_desc: 'PhD in Materials Engineering, 10 years focused on pet product material R&D, led the development of Koorpet\'s low-dust formula and catnip infusion process.',
  team3_tag1: 'Materials R&D',
  team3_tag2: 'Process Innovation',
  team4_name: 'Zhang Meiling',
  team4_role: 'Quality Director',
  team4_desc: 'Holds ISO quality management system certification, responsible for quality control across all Koorpet product lines, ensuring every product meets factory standards.',
  team4_tag1: 'Quality Control',
  team4_tag2: 'ISO Certified',

  // Certificates
  cert_label: 'Certifications',
  cert_title: 'Credentials & Certifications',
  cert_desc: 'Multiple authoritative certifications — the best proof of Koorpet\'s quality and innovation',
  cert1_title: 'ISO 9001',
  cert1_sub: 'Quality Management System',
  cert1_desc: 'Passed international quality management system certification, fully traceable production process, quality guaranteed.',
  cert1_year: 'Obtained in 2018',
  cert2_title: 'Eco Non-Toxic Cert.',
  cert2_sub: 'National Eco Testing Passed',
  cert2_desc: 'All materials pass national environmental testing — formaldehyde-free, heavy metal-free, safe even if cats chew on it.',
  cert2_year: 'Obtained in 2017',
  cert3_title: 'Pet Product Safety Cert.',
  cert3_sub: 'China Pet Products Association',
  cert3_desc: 'Awarded safety certification by the China Pet Products Association, one of the few brands in the industry to receive this certification.',
  cert3_year: 'Obtained in 2019',
  cert4_title: 'CE European Cert.',
  cert4_sub: 'EU Market Access',
  cert4_desc: 'Passed EU CE certification, products meet EU safety, health and environmental standards, eligible for sale in the EU market.',
  cert4_year: 'Obtained in 2020',

  // About CTA
  about_cta_label: 'Join Us',
  about_cta_title1: 'Together, Let\'s Create',
  about_cta_title2: 'A Better Life for Cats',
  about_cta_btn1: 'Explore Products',
  about_cta_btn2: 'Contact Us',

  // Products Banner
  products_breadcrumb_home: 'Home',
  products_breadcrumb: 'Products',
  products_banner_title: 'Product Center',
  products_banner_desc: 'Premium natural materials, crafted with care — every cat scratcher made to make cats love their scratching ritual',

  // Product Filter
  filter_all: 'All',
  filter_count: '',
  filter_count2: 'products found',
  sort_default: 'Default',
  sort_price_asc: 'Price: Low to High',
  sort_price_desc: 'Price: High to Low',
  category_corrugated: 'Corrugated',
  category_sisal: 'Sisal',
  category_combo: 'Combo',

  // Product Card
  product_view_detail: 'View Details',

  // Product Detail
  detail_product_code: 'Product Code',
  detail_not_found: 'Product not found',
  detail_back_to_products: 'Back to Products',

  // Tags
  tag_hot_selling: 'Hot Selling',
  tag_new: 'New',
  tag_corrugated_paper: 'Corrugated',
  tag_limited_offer: 'Limited Offer',
  tag_bestseller: 'Bestseller',
  tag_recommended: 'Recommended',
  tag_catnip: 'Catnip',
  tag_sisal: 'Sisal',
  tag_corner_protector: 'Corner Protector',
  tag_cat_tree: 'Cat Tree',
  tag_eco_friendly: 'Eco-Friendly',

  tag_double_sided: 'Double-Sided',
  tag_sofa_protector: 'Sofa Protector',
  tag_multi_function: 'Multi-Function',

  detail_tab_desc: 'Description',
  detail_tab_specs: 'Specifications',
  detail_tab_faq: 'FAQ',
  detail_spec_material: 'Material',
  detail_spec_size: 'Size',
  detail_spec_weight: 'Weight',
  detail_spec_moq: 'MOQ',
  detail_spec_suitable: 'Suitable For',
  detail_spec_suitable_val: 'All sizes',
  detail_spec_package: 'Package Contents',
  detail_spec_package_val: 'Product × 1, Manual × 1',

  detail_save: 'Save ',
  detail_save_unit: '',
  detail_btn_consult: 'Inquire to Buy',
  related_title: 'You May Also Like',
  related_view_all: 'View All',

  // Highlight titles
  highlight_title_triple_layer: 'Triple-Layer Press',
  highlight_title_catnip_infused: 'Organic Catnip Infused',
  highlight_title_eco_certified: 'Eco Certified',
  highlight_title_anti_slip: 'Anti-Slip Base',
  highlight_title_natural_sisal: 'Natural Sisal Rope',
  highlight_title_solid_wood: 'Solid Wood Base',
  highlight_title_golden_height: 'Perfect 60cm Height',
  highlight_title_nail_care: 'Natural Nail Care',
  highlight_title_double_sided: 'Double-Sided Use',
  highlight_title_wave_curve: 'Wave Curve Design',
  highlight_title_low_dust: 'Low Dust Formula',
  highlight_title_rubber_strip: 'Anti-Slip Rubber Strip',
  highlight_title_sofa_design: 'Sofa-Specific Design',
  highlight_title_tool_free: 'Tool-Free Install',
  highlight_title_sofa_safe: 'Sofa Surface Safe',
  highlight_title_set_of_4: 'Set of 4 Pieces',
  highlight_title_catnip_builtin: 'Built-in Catnip',
  highlight_title_round_design: 'Elegant Round Design',
  highlight_title_safe_edge: 'Safe Edge Finish',
  highlight_title_hot_seller: 'Best Seller',
  highlight_title_three_level: 'Three-Level Platform',
  highlight_title_15kg_capacity: '15kg+ Capacity',
  highlight_title_hanging_toy: 'Hanging Toy Included',
  highlight_title_wide_base: 'Wide Stable Base',
  // Highlight descriptions
  highlight_desc_triple_layer: '2x denser than ordinary, more durable',
  highlight_desc_catnip_infused: 'Lasting fragrance, cats naturally drawn',
  highlight_desc_eco_certified: 'Safe even if chewed or nibbled',
  highlight_desc_anti_slip: 'Stays firmly in place during use',
  highlight_desc_natural_sisal: 'Hand-wound, even thickness, great toughness',
  highlight_desc_solid_wood: 'Treated pine, stable and sturdy',
  highlight_desc_golden_height: 'Perfect for cats to stretch and scratch',
  highlight_desc_nail_care: 'Naturally trims claws, protects furniture',
  highlight_desc_double_sided: 'Flip over for double the lifespan',
  highlight_desc_wave_curve: 'Matches cats\' natural scratching posture',
  highlight_desc_low_dust: 'Less debris, keeps your home clean',
  highlight_desc_rubber_strip: 'Stays firmly in place during use',
  highlight_desc_sofa_design: 'Perfect fit for sofa corners, full protection',
  highlight_desc_tool_free: 'Strong velcro, done in 30 seconds',
  highlight_desc_sofa_safe: 'Protective backing leaves no marks',
  highlight_desc_set_of_4: 'Protects all four sofa corners at once',
  highlight_desc_catnip_builtin: 'Solves the problem of cats ignoring scratchers',
  highlight_desc_round_design: 'Floor or wall mount, dual-purpose',
  highlight_desc_safe_edge: 'No burrs, completely safe for cats',
  highlight_desc_hot_seller: '5000+ sold monthly, highly rated',
  highlight_desc_three_level: 'Satisfies cats\' instinct to climb high',
  highlight_desc_15kg_capacity: 'Safe for multi-cat households',
  highlight_desc_hanging_toy: 'Sparks your cat\'s play instinct',
  highlight_desc_wide_base: 'Won\'t tip over even when jumped on',

  // Contact Banner
  contact_breadcrumb_home: 'Home',
  contact_breadcrumb: 'Contact',
  contact_banner_title: 'Contact Us',
  contact_banner_desc: 'Whether it\'s product inquiries, business cooperation or after-sales service, we\'re always ready to help',

  // Contact Form
  contact_form_label: 'Send Message',
  contact_form_title: 'Leave Us a Message',
  contact_form_desc: 'Fill in the form below and we\'ll reply within 1 business day',
  contact_form_success_title: 'Message Sent!',
  contact_form_success_desc: 'Thank you for your message. We\'ll get back to you within 1 business day.',
  contact_form_success_btn: 'Send Another',
  contact_form_name: 'Your Name',
  contact_form_name_placeholder: 'Enter your name',
  contact_form_phone: 'Phone Number',
  contact_form_phone_placeholder: 'Enter your phone number',
  contact_form_email: 'Email Address',
  contact_form_email_placeholder: 'Enter your email address',
  contact_form_inquiry: 'Inquiry Type',
  contact_form_company: 'Company Name',
  contact_form_company_optional: '(Optional)',
  contact_form_company_placeholder: 'Enter company name if applicable',
  contact_form_message: 'Message',
  contact_form_message_placeholder: 'Please describe your needs or questions in detail...',
  contact_form_required: '*',
  contact_form_error: 'Failed to send. Please try again later.',
  contact_form_sending: 'Sending...',
  contact_form_submit: 'Send Message',
  inquiry_type1: 'Product Inquiry',
  inquiry_type2: 'Wholesale Cooperation',
  inquiry_type3: 'After-Sales Service',
  inquiry_type4: 'Media Cooperation',
  inquiry_type5: 'Other',

  // Contact CTA
  contact_cta_title: 'Still Have Questions?',
  contact_cta_desc: 'Check our FAQ, or email us directly at',
  contact_cta_btn_browse: 'Browse Products',
  contact_cta_btn_email: 'Send Email',

  // Products CTA
  products_cta_title: 'Can\'t Find the Right Product?',
  products_cta_desc: 'Contact us for customized solutions tailored to your specific needs',
  products_cta_btn: 'Contact Us',

  // Contact Info
  contact_info1_title: 'Company Address',
  contact_info1_line1: 'FLAT /RM A 9/F SILVERCORP',
  contact_info1_line2: 'INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  contact_info1_action: 'View Map',
  contact_info2_title: 'Customer Service',
  contact_info2_line1: 'Customer Service',
  contact_info2_line2: 'Mon–Fri 9:00 AM – 6:00 PM',
  contact_info2_action: 'Chat Now',
  contact_info3_title: 'Email',
  contact_info3_line1: 'cs@koorpet.com',
  contact_info3_line2: 'Business: cs@koorpet.com',
  contact_info3_action: 'Send Email',
  contact_info4_title: 'WhatsApp',
  contact_info4_line1: 'Koorpet Official',
  contact_info4_line2: 'Chat with us directly on WhatsApp',
  contact_info4_action: 'Start Chat',

  // Footer
  footer_brand_desc: 'Dedicated to cat scratcher R&D and production, giving every cat their own happy territory.',
  footer_nav_title: 'Quick Links',
  footer_products_title: 'Product Lines',
  footer_product1: 'Corrugated Scratchers',
  footer_product2: 'Sisal Scratching Posts',
  footer_product3: 'Cat Tree Series',
  footer_product4: 'Corner Protectors',
  footer_product5: 'Catnip Series',
  footer_contact_title: 'Contact Us',
  footer_address: 'FLAT /RM A 9/F SILVERCORP INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  footer_phone: 'Mon–Fri 9:00 AM – 6:00 PM',
  footer_whatsapp: 'WhatsApp',
  footer_email: 'cs@koorpet.com',
  footer_hours: 'Mon–Fri 9:00 AM – 6:00 PM',
  footer_copyright: '© 2026 DANA INTERNATIONAL (HK) CO., LIMITED',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Use',
  footer_admin: 'Admin',

  // Legal Page
  legal_breadcrumb: 'Legal',
  legal_banner_title: 'Legal Information',
  legal_banner_desc: 'Please read the following terms carefully to understand how we protect your rights',
  legal_updated: 'Last updated',

  // Privacy Policy
  privacy_s1_title: 'About This Policy',
  privacy_s1_p1: 'DANA INTERNATIONAL (HK) CO., LIMITED (hereinafter "Koorpet" or "we") takes user privacy very seriously. This Privacy Policy explains how we collect, use, store, and protect your personal information.',
  privacy_s1_p2: 'By using our website, products, or services, you agree to the terms of this Privacy Policy. If you do not agree, please stop using our services.',
  privacy_s2_title: 'Information We Collect',
  privacy_s2_p1: 'To provide better services, we may collect the following types of information:',
  privacy_s2_li1: 'Identity information: name, phone number, email address',
  privacy_s2_li2: 'Transaction information: order history, shipping address, payment details',
  privacy_s2_li3: 'Device information: IP address, browser type, operating system',
  privacy_s2_li4: 'Usage data: page visit records, click behavior, search keywords',
  privacy_s3_title: 'How We Use Your Information',
  privacy_s3_p1: 'The information we collect will be used for the following purposes:',
  privacy_s3_li1: 'Processing your orders and providing related after-sales services',
  privacy_s3_li2: 'Sending you product updates and promotional notifications (you can unsubscribe at any time)',
  privacy_s3_li3: 'Improving our website functionality and user experience',
  privacy_s4_title: 'Information Sharing and Disclosure',
  privacy_s4_p1: 'We do not sell your personal information to third parties. We may share your information in the following circumstances:',
  privacy_s4_p2: 'Sharing delivery information with logistics partners; complying with legal requirements; with your explicit authorization.',
  privacy_s5_title: 'Information Security',
  privacy_s5_p1: 'We use industry-standard security measures to protect your personal information, including SSL encrypted transmission and data access controls. Please note that internet transmission is not absolutely secure, and we cannot guarantee the absolute security of information transmission.',
  privacy_s6_title: 'Your Rights',
  privacy_s6_p1: 'You have the following rights regarding your personal information:',
  privacy_s6_li1: 'Right of access: You can access your personal information held by us at any time',
  privacy_s6_li2: 'Right of correction: If information is incorrect, you can request us to correct it',
  privacy_s6_li3: 'Right of deletion: In certain circumstances, you can request us to delete your personal information',
  privacy_s7_title: 'Contact Us',
  privacy_s7_p1: 'If you have any questions about this Privacy Policy, please contact us at:',

  // Terms of Use
  terms_s1_title: 'Acceptance of Terms',
  terms_s1_p1: 'Welcome to the Koorpet official website. By accessing or using this website, you agree to be bound by these Terms of Use.',
  terms_s1_p2: 'We reserve the right to modify these terms at any time. Modified terms will be posted on the website, and continued use of the website constitutes acceptance of the modified terms.',
  terms_s2_title: 'Products and Purchases',
  terms_s2_p1: 'When purchasing products through this website, you must comply with the following:',
  terms_s2_li1: 'All information you provide must be true, accurate, and complete',
  terms_s2_li2: 'You must be at least 18 years old or use the service with guardian consent',
  terms_s2_li3: 'Product prices may change at any time; the price displayed at the time of order placement applies',
  terms_s3_title: 'Shipping and Delivery',
  terms_s3_p1: 'We will make every effort to deliver products within the promised timeframe, but actual delivery times may vary due to logistics conditions.',
  terms_s3_p2: 'Delivery scope, shipping fees, and estimated arrival times are subject to what is displayed on the checkout page. In case of delays due to force majeure, we will notify you promptly.',
  terms_s4_title: 'Return and Exchange Policy',
  terms_s4_p1: 'We are committed to providing excellent after-sales service. Our return and exchange policy is as follows:',
  terms_s4_li1: 'Within 7 days of receiving the product, if there is a quality issue, you may apply for a return or exchange',
  terms_s4_li2: 'Products must be in original packaging, unused and undamaged',
  terms_s4_li3: 'Return shipping costs are borne by the responsible party; if it is a quality issue, we bear the shipping costs',
  terms_s5_title: 'Intellectual Property',
  terms_s5_p1: 'All content on this website, including but not limited to text, images, logos, and product designs, is protected by intellectual property laws and belongs to Koorpet.',
  terms_s5_p2: 'Without our written permission, you may not copy, modify, distribute, or use any content from this website in any way.',
  terms_s6_title: 'Disclaimer',
  terms_s6_p1: 'The content of this website is for reference only. We are not responsible for any direct or indirect losses arising from the use of this website or reliance on its information. Product images are for reference only; the actual product received shall prevail.',
  terms_s7_title: 'Governing Law',
  terms_s7_p1: 'These Terms of Use are governed by the laws of the People\'s Republic of China. In case of disputes, both parties shall first attempt to resolve them through negotiation; if negotiation fails, the dispute shall be submitted to the competent courts in Hong Kong SAR.',
  terms_s8_title: 'Contact Us',
  terms_s8_p1: 'If you have any questions about these Terms of Use, please contact us at:',
};

export default en;